import { __rest, __assign } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { useRadio } from './RadioGroup.js';
import { Wrapper, Field, StyledRadio, Label } from './styles.js';

var Radio = function (_a) {
    var error = _a.error, disabled = _a.disabled, label = _a.label, value = _a.value, props = __rest(_a, ["error", "disabled", "label", "value"]);
    var _b = useRadio(), name = _b.name, onChange = _b.onChange, selectedRadio = _b.selectedRadio, readOnly = _b.readOnly;
    var checked = selectedRadio === value;
    return (React.createElement(Wrapper, { hasLabel: Boolean(label) },
        React.createElement(Field, __assign({}, props, { id: String(value), name: name, value: value, error: error, readOnly: readOnly, onChange: onChange, disabled: disabled || readOnly, "aria-readonly": readOnly, checked: checked, type: "radio", hasLabel: Boolean(label) })),
        React.createElement(StyledRadio, { error: error, disabled: disabled, readOnly: readOnly }),
        label && React.createElement(Label, { htmlFor: String(value) }, label)));
};
Radio.displayName = 'RadioGroup.Radio';

export { Radio as default };
